import * as betprofessor from './SelectionPopup.styles.betprofessor';
import * as betroyale from './SelectionPopup.styles.betroyale';
import * as fiestabet from './SelectionPopup.styles.fiestabet';
import * as puntcity from './SelectionPopup.styles.puntcity';
import * as puntgenie from './SelectionPopup.styles.puntgenie';
import * as questbet from './SelectionPopup.styles.questbet';
import * as sterlingparker from './SelectionPopup.styles.sterlingparker';
import * as vikingbet from './SelectionPopup.styles.vikingbet';
import * as volcanobet from './SelectionPopup.styles.volcanobet';
import * as goldenrush from './SelectionPopup.styles.goldenrush';
import * as juicybet from './SelectionPopup.styles.juicybet';
import * as forsport from './SelectionPopup.styles.forsport';
import * as junglebet from './SelectionPopup.styles.junglebet';
import * as betgalaxy from './SelectionPopup.styles.betgalaxy';
import * as sugarcastle from './SelectionPopup.styles.sugarcastle';
import * as wellbet from './SelectionPopup.styles.wellbet';
import * as oldgill from './SelectionPopup.styles.oldgill';
import * as buffalobet from './SelectionPopup.styles.buffalobet';
import * as titanbet from './SelectionPopup.styles.titanbet';
import * as slambet from './SelectionPopup.styles.slambet';
import * as gigabet from './SelectionPopup.styles.gigabet';
import * as betstride from './SelectionPopup.styles.betstride';
import * as templebet from './SelectionPopup.styles.templebet';
import * as goldenbet888 from './SelectionPopup.styles.goldenbet888';
import * as hyperbet from './SelectionPopup.styles.hyperbet';
import * as bet777 from './SelectionPopup.styles.bet777';
import * as chromabet from './SelectionPopup.styles.chromabet';
import * as bet575 from './SelectionPopup.styles.bet575';
import * as betblast from './SelectionPopup.styles.betblast';
import * as pyramidbet from './SelectionPopup.styles.pyramidbet';
import * as magnumbet from './SelectionPopup.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  wellbet,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  goldenrush,
  juicybet,
  forsport,
  junglebet,
  betgalaxy,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
